// supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
const supabaseServiceKey = import.meta.env.VITE_SUPABASE_SERVICE_ROLE_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    console.error('Missing Supabase environment variables');
}

// Single client instance with proper configuration
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        autoRefreshToken: true,
        persistSession: true,
        storageKey: 'supabase-auth-token', // Unique storage key
        storage: window?.localStorage, // Explicit storage
    },
    global: {
        headers: {
            'X-Client-Info': 'supabase-js-web'
        }
    }
});

// Service client for admin operations (bypasses RLS)
export const supabaseAdmin = createClient(supabaseUrl, supabaseServiceKey || supabaseAnonKey, {
    auth: {
        autoRefreshToken: false,
        persistSession: false,
        storageKey: 'supabase-admin-token', // Different storage key
    },
    global: {
        headers: {
            'X-Client-Info': 'supabase-js-admin'
        }
    }
});

// Use the same client for regular operations to avoid conflicts
export const supabaseService = supabase;

// Helper function to handle lock timeouts
export const withRetry = async (operation, maxRetries = 3, delay = 1000) => {
    for (let i = 0; i < maxRetries; i++) {
        try {
            return await operation();
        } catch (error) {
            if (error.message?.includes('NavigatorLockAcquireTimeoutError') && i < maxRetries - 1) {
                console.warn(`Lock timeout, retrying... (${i + 1}/${maxRetries})`);
                await new Promise(resolve => setTimeout(resolve, delay));
                continue;
            }
            throw error;
        }
    }
};
